const getContactIdFromObjectID = (objectID: string) => {
    const arr = objectID.split('/');
    return arr[arr.length - 1];
};

export default getContactIdFromObjectID;
